import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const k = { key: 0 }, M = { key: 1 }, Z = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, A = {
  name: "ScalarIconCaretUp"
}, L = /* @__PURE__ */ i({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = f(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", k, t[0] || (t[0] = [
        n("path", { d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M208,160H48l80-80Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", Z, t[2] || (t[2] = [
        n("path", { d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", h, t[3] || (t[3] = [
        n("path", { d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", w, t[4] || (t[4] = [
        n("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", y, t[5] || (t[5] = [
        n("path", { d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
